// extracted by mini-css-extract-plugin
export default {"privacy":"Battle_privacy__A+6PP","listLink":"Battle_listLink__AFH1g"};